<section class="flow-root">
  <div class="flow-root__wrapper">
    <header class="header">
      <div class="container-fluid">
        <div class="row">
          <div
            class="col-12 col-lg-5 order-1 order-lg-0 d-flex align-items-center justify-content-center justify-content-lg-start mt-3 mt-lg-0"
          >
            <img src="/assets/images/logo-flow.svg" width="100" alt="" />
            <img src="/assets/images/card.svg" class="header__card" alt="" />
          </div>
          <div class="col-12 col-lg-7 header__panel">
            <div class="text-center text-lg-end">
              <span class="d-none d-lg-inline">{{ 'FlowLayout.help' | translate }}</span>
              <img src="/assets/images/icons/phone.svg" alt="" class="header__icon mx-1" />
              <a [href]="config.getSetting('tel_phone')" class="header__phone">{{ config.getSetting('phone') }}</a>
              <span class="d-none d-lg-inline ms-1">
                | {{ 'FlowLayout.text1' | translate }} {{ 'CommonTexts.openTime' | translate }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </header>

    <main>
      <div class="container-fluid">
        @if (serviceNotification()?.loanprocess) {
          <div [class]="serviceNotification()?.style">
            {{ serviceNotification()?.message }}
          </div>
        }
        <router-outlet />
      </div>
    </main>

    <footer class="footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-lg-5 d-none d-lg-flex align-self-center">
            <img src="/assets/images/logo-flow-footer.svg" width="100" alt="" />
          </div>
          <div class="col-12 col-lg-7 footer__details">
            <address class="footer__address">
              <p>GF Card</p>
              Carl Jacobsen vej 16<br />
              opgang 6, 4.sal<br />
              2500 valby
            </address>

            <nav class="footer__nav mt-1 mt-lg-0 ms-lg-15 ms-xl-20">
              <p>{{ 'FlowLayout.openTime' | translate }} 9-16</p>
              <img src="/assets/images/icons/cellar.svg" alt="" class="me-1" />{{ 'FlowLayout.phone' | translate }}:
              <a [href]="config.getSetting('tel_phone')">{{ config.getSetting('phone') }}</a
              ><br />
              <img src="/assets/images/icons/email.svg" alt="" class="me-1" /><a
                [href]="config.getSetting('mailto_email')"
                >{{ config.getSetting('email') }}</a
              >
            </nav>
          </div>
        </div>
      </div>
    </footer>
  </div>
</section>

<app-success-message></app-success-message>
<app-error-message></app-error-message>
